import React from 'react';
import { FiPlus, FiTrash2 } from 'react-icons/fi';

const FormMaterial = ({
  formData,
  handleChange,
  availableMaterials,
  selectedMaterial,
  setSelectedMaterial,
  onAddMaterial,
  onRemoveMaterial,
  formatCurrency,
  materialTotal,
  grandTotal
}) => {
  const laborCost = parseInt(formData.laborCost) || 0;

  return (
    <div className="bg-[var(--bg-primary)] p-6 rounded-xl shadow-[var(--shadow-sm)] border border-[var(--border-color)]">
      <h3 className="text-lg font-semibold text-[var(--text-primary)] mb-4">
        Material & Biaya
      </h3>

      {/* Pilih Material */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-3">
        <div>
          <label className="block text-sm text-[var(--text-secondary)] mb-1">
            Pilih Material
          </label>
          <select
            value={selectedMaterial.id}
            onChange={(e) => {
              const material = availableMaterials.find(m => m.id === e.target.value);
              setSelectedMaterial({
                id: material?.id || '',
                qty: 1,
                name: material?.name || '',
                price: material?.sellPrice || 0
              });
            }}
            className="w-full px-3 py-2 border border-[var(--border-color)] rounded-lg bg-[var(--bg-primary)] text-[var(--text-primary)] focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="">-- Pilih Bahan --</option>
            {availableMaterials.map((m) => (
              <option key={m.id} value={m.id}>
                {m.name} (Stok: {m.stock}) - {formatCurrency(m.sellPrice)}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm text-[var(--text-secondary)] mb-1">
            Qty
          </label>
          <input
            type="number"
            min="1"
            value={selectedMaterial.qty}
            onChange={(e) => setSelectedMaterial({
              ...selectedMaterial,
              qty: parseInt(e.target.value) || 1
            })}
            className="w-full px-3 py-2 border border-[var(--border-color)] rounded-lg bg-[var(--bg-primary)] text-[var(--text-primary)] focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div className="flex items-end">
          <button
            type="button"
            onClick={onAddMaterial}
            disabled={!selectedMaterial.id}
            className="w-full px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg disabled:opacity-50 flex items-center justify-center gap-2"
          >
            <FiPlus size={18} />
            Tambah
          </button>
        </div>
      </div>

      {/* List Material */}
      {formData.materials.length > 0 && (
        <div className="overflow-x-auto mt-3">
          <table className="w-full text-sm">
            <thead className="bg-[var(--bg-secondary)]">
              <tr>
                <th className="px-3 py-2 text-left">Nama</th>
                <th className="px-3 py-2 text-center">Qty</th>
                <th className="px-3 py-2 text-right">Harga</th>
                <th className="px-3 py-2 text-right">Subtotal</th>
                <th className="px-3 py-2 text-center">Aksi</th>
              </tr>
            </thead>
            <tbody>
              {formData.materials.map((item, index) => (
                <tr key={index} className="border-b border-[var(--border-color)]">
                  <td className="px-3 py-2">{item.name}</td>
                  <td className="px-3 py-2 text-center">{item.qty}</td>
                  <td className="px-3 py-2 text-right">{formatCurrency(item.price)}</td>
                  <td className="px-3 py-2 text-right">{formatCurrency(item.qty * item.price)}</td>
                  <td className="px-3 py-2 text-center">
                    <button
                      type="button"
                      onClick={() => onRemoveMaterial(index)}
                      className="text-red-500 hover:text-red-700"
                    >
                      <FiTrash2 size={16} />
                    </button>
                  </td>
                </tr>
              ))}
              <tr className="font-bold bg-[var(--bg-secondary)]">
                <td colSpan="3" className="px-3 py-2 text-right">Total Material</td>
                <td className="px-3 py-2 text-right">{formatCurrency(materialTotal)}</td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
      )}

      {/* Labor Cost & Total */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mt-3">
        <div>
          <label className="block text-sm text-[var(--text-secondary)] mb-1">
            Biaya Pekerjaan - Labor Cost
          </label>
          <input
            type="number"
            name="laborCost"
            value={formData.laborCost}
            onChange={handleChange}
            min="0"
            placeholder="Masukkan biaya jasa / upah"
            className="w-full px-3 py-2 border border-[var(--border-color)] rounded-lg bg-[var(--bg-primary)] text-[var(--text-primary)]"
          />
          <p className="text-xs text-[var(--text-secondary)] mt-1">
            * Biaya jasa / upah tukang
          </p>
        </div>
        <div className="flex items-center">
          <div className="w-full px-3 py-2 bg-[var(--bg-secondary)] rounded-lg">
            <p className="text-sm text-[var(--text-secondary)]">
              Total Biaya (Labor + Material)
            </p>
            <p className="text-lg font-bold text-[var(--text-primary)]">
              {formatCurrency(grandTotal)}
            </p>
            <p className="text-xs text-[var(--text-secondary)] mt-0.5">
              Labor {formatCurrency(laborCost)} + Material {formatCurrency(materialTotal)}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormMaterial;